<template>
    <a href="http://ohaio.ai" target="_blank" rel="noopener noreferrer">
        <img src="@/assets/logo.webp" alt="Logo" class="logo" />
    </a>
</template>
<script>
export default {
    name: 'AppLogo',
}
</script>
<style scoped>
.logo {
    position: fixed;
    top: 8px;
    left: 8px;
    width: 48px;
    height: auto;
    z-index: 9999;
}

@media (max-width: 768px) {
    .logo {
        width: 32px;
        top: 16px;
        left: 16px;
    }
}
</style>